import React from "react";
import { ChevronDown } from "lucide-react";

const AccordionSection = ({ title, isOpen, isComplete, onToggle, children }) => {
  return (
    <div className="border-b border-gray-100">
      <button
        onClick={onToggle}
        className="w-full p-4 flex items-center justify-between bg-white"
      >
        <div className="flex items-center gap-3">
          <span className={`w-6 h-6 rounded-full flex items-center justify-center ${
            isComplete ? 'bg-green-500 text-white' : 'bg-gray-200'
          }`}>
            {isComplete ? '✓' : ''}
          </span>
          <span className="font-medium">{title}</span>
        </div>
        <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="p-4 bg-gray-50">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionSection;